import { ReactNode } from 'react';
import { useAuth } from '../../utils/Auth/AuthProvider';

type Role = 'superuser' | 'school' | 'college_university' | 'admin'
  | 'school_admin' | 'teacher' | 'counselor' | 'student' | 'staff';

interface Props {
  allow: Role[];
  children: ReactNode;
  fallback?: ReactNode;
}

export default function RoleGate({ allow, children, fallback }: Props) {
  const { role } = useAuth();
  // 'superuser' is always allowed unless explicitly excluded by the allow list.
  const allowed = role === 'superuser' || (role && (allow as string[]).includes(role));
  if (allowed) return <>{children}</>;
  if (fallback) return <>{fallback}</>;
  return (
    <div className="rounded border border-yellow-300 bg-yellow-50 p-4 text-yellow-900">
      You are not authorized to view this page.
    </div>
  );
}
